import Vue from 'vue'
import App from './App.vue'
import './registerServiceWorker'
import router from './router'
import store from './store'
import axios from 'axios'
// 引入 ElementUI组件
import ElementUI from 'element-ui';
//引入 ElementUI的样式
import 'element-ui/lib/theme-chalk/index.css';
import 'babel-polyfill'


import vueClamp from 'vue-clamp'
Vue.component("vueClamp",vueClamp);

// import mixin from './assets/mymixin'
// Vue.mixin(mixin)

Vue.use(ElementUI);
Vue.config.productionTip = false
Vue.prototype.$axios = axios
axios.defaults.baseURL = "http://3d.sanweiquan.cn/onedata/";
new Vue({
  router,
  store,
  render: h => h(App),
}).$mount('#app')

